import { resolveGeoLocale } from '@/i18n/geoLocale'
import { useLocaleStore } from '@/stores/general/localeStore'
import router from '@/router'

export async function initLocale() {
  const result = await resolveGeoLocale()
  if (!result) return

  localStorage.setItem('locale', result.locale)
  localStorage.setItem('localeFlag', result.flag)
  localStorage.setItem('localeCountry', result.country)
  localStorage.setItem('localeStoredAt', String(Date.now()))

  const localeStore = useLocaleStore()
  localeStore.set(result.flag, result.country)

  const currentRoute = router.currentRoute.value
  if (currentRoute.params.locale && currentRoute.params.locale !== result.locale) {
    router.push({
      name: currentRoute.name,
      params: { ...currentRoute.params, locale: result.locale },
      query: currentRoute.query,
    })
  }
}
